import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <div className="max-w-[900px] mx-auto px-6 lg:px-10 py-24" data-testid="not-found-page">
      <Seo title="Page not found" noindex />
      <h1 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight text-[#0A2540]">Page not found</h1>
      <p className="mt-4 text-lg text-slate-600">We could not find that page.</p>
      <Link to="/" className="btn-green mt-8 inline-flex">Back to homepage</Link>
    </div>
  );
}
